import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SettingsMenuState {
    openChildRoutePaths: string[];
}

const INITIAL_STATE: SettingsMenuState = {
    openChildRoutePaths: [],
};

const SETTINGS_MENU_SLICE = createSlice({
    name: "settingsMenuStore",
    initialState: INITIAL_STATE,
    reducers: {
        toggleChildRoutePath(state, action: PayloadAction<string>) {
            const path = action.payload;
            if (state.openChildRoutePaths.includes(path)) {
                state.openChildRoutePaths = state.openChildRoutePaths.filter((openPath) => openPath !== path);
            } else {
                state.openChildRoutePaths.push(path);
            }
        },
        resetChildRoutePaths(state) {
            state.openChildRoutePaths = INITIAL_STATE.openChildRoutePaths;
        },
    },
});

export const { toggleChildRoutePath, resetChildRoutePaths } = SETTINGS_MENU_SLICE.actions;

export default SETTINGS_MENU_SLICE.reducer;
